import { Component, OnInit, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, ViewChild } from '@angular/core';


import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as echarts from 'echarts';

import { ToastrService } from 'ngx-toastr'
import { ToastController } from '@ionic/angular';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExtendDueDatePopupComponent } from 'src/app/shared/popups/extend-due-date-popup/extend-due-date-popup.component';
import { AddExpenseEmployeeComponent } from '../add-expense-employee/add-expense-employee.component';
import { formatText } from 'src/app/shared/commen-function-file';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSelect } from '@angular/material/select';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.scss'],

})
export class ExpenseComponent implements OnInit {
  originalData: any[] = [];
  setupId: any;
  setupGradeBrand: any;
  public restrictToEditSetup: boolean = false;
  restrictToEditBandOrGrade: boolean = false;
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  isInValidMaxRange: boolean = false;
  loggedInUserEmpCode: any;
  sleectedUserforCompetencySetup: any;
  showMaxRangeError: boolean = false;
  allowedToEditTeamCompetency: boolean = false;
  allowedToEditManagerMycompetency: boolean = false;
  errorMessage: string = '';
  reimbursementAdd: any;
  reimbursement: any;
  selectedEmployee: any;
  selectedDate: any;
  readonlyFlag = false;
  tableData: { scoreRange: string; maxRange: string; rating: string }[] = [];
  reimbursementTable: { reimbursementId: any, reimbursementType: string, band: any, amountLimit: any; }[] = [];
  editReimbursemendData: boolean = false;
  reimbursementAddId: any;
  reimbursementIDforEdit: any;

  columnVisibility: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };
  chartOptions: echarts.EChartsOption | undefined;

  selectedEmployeeDashboardId: any;



  comparisonEmpIdsForSecondLast: any = [];

  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];


  setUpyearRange: any;
  loggedInCompanyMDCode: any;
  bandListData: any;
  getBandData: any;
  getLocationData: any;
  getAllFinanceUserDD: any;
  bandRecord: any;
  isLimitTypeLocked: boolean = false;
  showAddNewSaveBtn: boolean = true;
  getIndirectEmployees: any;
  selectedEmployeeIdForReport: any;
  completedTaskStatusCount: any;
  taskIsReviewByEmployee: any;
  sortName: any;
  sortBy: any;
  dWMReportTaskList: any;
  selectedTaskList: any = [];
  selectAllTaskCheckbox: boolean = false;
  reimbursementgetData: any;
  editableIndex: any;
  selectedManagerDashboardId: boolean = false;
  reimbursementTablefrontendSide: any;
  selectedKpiScoreSummaryfromDate: any;
  selectedKpiUser: any;
  EmployeeSummaryData: any = [];
  approveMatrixValueForCondition: any;
  selectedFinanceEmployee: any = [];
  deleteByReimbursementType: boolean = false;
  isShowEmployee: boolean = false;
  isHODLoginCheck: any;
  tempBandListData: any;
  selectEmployeeIdByManager: any;
  selectRowId: any;
  isLoginFinanceEnable: boolean = true;
  loggedInHODManager: any;


  // Debugging function
  logColumnVisibility() {
  }

  onCheckboxChangeCheck(column: string, event: any) {
    this.columnVisibility[column] = event.checked;
    this.logColumnVisibility(); // Debugging call
  }

  checkboxState: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };

  competencyMapping: any = null;
  previousMaxRange: string = '0';
  showInputs: boolean = false;
  employeetotalweight: number[] = [];
  hradminCompetency: any[] = [];
  scoreRange: number | any;
  dropdownSettings: IDropdownSettings = {};
  maxRange: any = null;
  setupSubRatingId: any
  rating: string = '';
  ratings: string[] = [];
  isDuplicateRating: boolean = false;
  competencyYear: any;
  evaluationPeriod: any = null;
  editIndex: number | null = null;
  setupForm: boolean = false
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard'
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;
  currentDate: any = new Date;
  competencyemployee: any = [];
  toDate: any;
  fromDate: any;
  selectedFunction: string = '';
  selectedBands: any[] = [];
  selectedBandForManager: string[] = [];
  uniqueFunctions: any[] = [];
  uniqueBands: any[] = [];
  competencySetupInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  startItemhr: number = 0;
  endItemhr: number = 0;
  selectedYearForCompetency: any = null;
  selectedYearForGraphOneHRAdmin: any = null;
  editedIndex: number | null = null;
  editedEmployeeCommentIndex: number | null = null;
  selectedOption: string = 'Top';


  loggedInCompanyFiscalyear: any;
  numbersOfDaysArray = Array.from({ length: 6 }, (_, i) => i + 1);
  wantLimit: string = '';                    // ngModel for 'Do You Want Limit?' radio buttons
  limitType: string = '';                    // ngModel for 'How Do You Want To At Limit?' radio buttons
  approveMatrix: string = '';
  selectedReimbursement: any;
  loggedInUserId: any;
  loggedInUserName: any
  loggedInUserRole: any;
  itemsdata: any;
  currentPageNumberOfKpis: any = 1;
  page: any = 0;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  pmsYears: any = [];
  getMonthsByFiscalandReviewCycle: any = [];
  fromYear: any = null;
  toYear: any = null;
  selectedItemsForPublish: Set<number> = new Set<number>();
  selectedItemsForDelete: Set<number> = new Set<number>();
  loggedInCompanyReviewCycle: any = null;
  deptListOfCompany: any;
  selectedDeptForKPISearch: any = null;
  goalSettingAtAllLevels: boolean = false;
  selectedYearReviewCycle: any;
  activeCustomReportBtn: boolean = false;
  isAllEmpForReportToggle: boolean = false;
  selectedGoalForEmp: any;
  selectedUserForKPIReport: any;
  activeReportBtnName: any = 'Scorecard';
  showTooltip: boolean = false;

  competencyListManagerView: any = []
  showFunction = true;
  showBand = true;
  showCompetencyName = true;
  showCompetencyDefinition = true;
  showWeightage = true;
  showPublishedOn = true;
  showCreatedBy = true;
  showLastModifiedBy = true;
  EditData = false;



  @ViewChild('employeeDropdown')
  employeeDropdown!: MatSelect;

  selectedTabIndex: number = 0
  constructor(public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef, public mobileResponsiveService: MobileResponsiveService
  ) {
    this.scoreRange = '0';
  }

  ngOnInit() {

    this.cdRef.detectChanges();

    this.loggedInHODManager = sessionStorage.getItem('HODManager');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;

    const validRoles = ['HOD', 'Employee'];

    const roleNames = this.loggedInUserRoles.map((role: any) => role.name);

    // Check if every role is either HOD or Employee AND no other role is present
    this.isHODLoginCheck = roleNames.every((role: any) => validRoles.includes(role)) && roleNames.length === validRoles.length;



    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }


    this.originalData = JSON.parse(JSON.stringify(this.competencyListManagerView));

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.getAllFunctionsByYearRangeReport();
    this.getpmsyearlist();
    this.getAllBand();
    this.getAllLocation();
    // this.getAllUserDD();

    this.getEmployee();
    // setTimeout(() => {

    //   this.getallReimbursementsForId();
    //   this.getallReimbursements();
    //   this.getAllEmployeesByDept();
    //   // this.getAllEmployeeListing();
    // }, 500)



  }

  formatedataVariable = formatText;
  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {


      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;

          // this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          // this.getDepartmentsByCompany();
        }
        else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true; // Set up a manager-specific action
          // Call a manager-specific method if needed
        }

        else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;
          // this.getUserByID();
        }

      }
    });
  }



  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,    // ✅ columns resize ho sakte hain
      sortable: true,  // ✅ sorting enable
      filter: true,  // ✅ filtering enable
      floatingFilter: true, // ✅ filters ki input box top me
      minWidth: 80,
      // ✅ rowIndex ke base pe alternate row styling (zebra effect)
      cellClass: (p: any) =>
        p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd'
    },
    context: { componentParent: this },  // ✅ agar component method call karna ho renderer/formatter se
    rowSelection: 'single',     // ✅ single row select
    singleClickEdit: true,       // ✅ click = edit (Pending wale case me helpful)
    stopEditingWhenCellsLoseFocus: true,    // ✅ focus lose hote hi editing stop
    // ✅ jab bhi cell update hoga, ye call hoga
    // onCellValueChanged: (event: any) => this.onCellValueChanged(event)
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  onCellValueChanged(event: any) {
    console.log("--------calue--", event.colDef.field)
    if (event.colDef.field === 'approvedByManager') {
      this.onApprovalChanged(event);
    } else if (event.colDef.field === 'managerComment') {
      this.onManagerCommentChanged(event);
    } else if (event.colDef.field === 'financeStatus') {
      this.onApprovalChangedForFinance(event);
    } else if (event.colDef.field === 'financeComment') {
      this.onFinanceCommentChanged(event);
    }
    else if (event.colDef.field === 'approvedByHrAdmin') {
      this.onApprovalChangedForHRAdmin(event);
    }

  }


  // ✅ Manager Comment update
  onManagerCommentChanged(event: any) {
    const rowData = event.data || event;
    const newValue = event.newValue;
    if (rowData.managerComment == null) {
      return;
    }
    let formData = {
      "managerComment": rowData.managerComment,
      "status": rowData?.approvedByManager || 'PENDING',
      "managerId": parseInt(this.loggedInUserId)
    }
    console.log(this.selectEmployeeIdByManager);

    // this.fetchAllReimbursementApplication(this.selectEmployeeIdByManager);

    this.httpService.callPutService(`${this.config.reimbursementsUpdateManager}/${rowData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {
          this.getAllEmployeeListing();
          this.toastr.success('Reimbursement Application  data updated by Manager Successfully', 'success');
        }
      });

  }




  onApprovalChangedForFinance(event: any) {
    console.log("fdkjdfkjdkfhkdfhkdfjh")
    if (event.colDef.field === 'financeStatus') {
      const rowData = event.data; // pura row data
      const newValue = event.newValue; // Approved ya Rejected

      if (rowData.assignedAmount == null && rowData?.financeStatus == 'APPROVED') {
        this.toastr.warning('Actual Amount By Finance is required', 'Warning');

        //  Reset back to PENDING
        rowData.financeStatus = 'PENDING';
        event.node.setDataValue('financeStatus', 'PENDING');
        return;
      }

      let formData = {
        "financeComment": rowData.financeComment,
        "approvedStatus": rowData?.financeStatus || 'PENDING',
        "assignedAmount": rowData.assignedAmount,
        "financeId": parseInt(this.loggedInUserId)
      }
      console.log(formData)
      this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${rowData.reimbursementApplicationId}`, formData)
        .subscribe((result) => {
          if (result) {
            this.getAllEmployeeListing();
            this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');

          }
        });

    }
  }

  // ✅ Finance Comment update
  onFinanceCommentChanged(event: any) {
    const rowData = event.data || event;
    const newValue = event.newValue;
    console.log(rowData);

    if (rowData.financeComment == null) {
      return;
    }

    let formData = {
      "financeComment": rowData.financeComment,
      "approvedStatus": rowData?.financeStatus || 'PENDING',
      "assignedAmount": rowData.assignedAmount,
      "financeId": parseInt(this.loggedInUserId)
    }

    this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${rowData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {
          this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');
        }
      });

  }
  // approval change in detail view
  onApprovalChangedDetailForFinance(newValue: string, row: any) {
    console.log('Approval changed in detail:', newValue, row);
    console.log(row);

    if (row.assignedAmount == null || row.assignedAmount == undefined) {
      this.toastr.warning('Actual Amount By Finance is required', 'Warning');
      // Forcefully dropdown ko PENDING set karo
      this.selectedRow = 'PENDING';  //  Force default 
      console.log(row)
      return;
    }
    const formData = {
      approvedStatus: newValue,
      financeComment: row.financeComment,
      assignedAmount: row.assignedAmount,
      reimbursementApplicationId: row.reimbursementApplicationId,
      financeId: parseInt(this.loggedInUserId)
    };

    this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${row.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {
          this.getAllEmployeeListing();
          this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');

        }
      });


  }




  onActualAmountChangedDetail(rowData: any) {
    if (!rowData.assignedAmount || rowData.assignedAmount <= 0) {
      this.toastr.warning('Actual Amount By Finance is required', 'Warning');
      return;
    }

    if (rowData.financeStatus === 'APPROVED' || rowData.financeStatus === 'REJECTED') {
      return; // prevent accidental update
    }

    const formData = {
      assignedAmount: rowData.assignedAmount,
      financeId: parseInt(this.loggedInUserId, 10),
      approvedStatus: rowData?.financeStatus || 'PENDING'
    };

    this.httpService.callPutService(
      `${this.config.reimbursementsUpdateFinance}/${rowData.reimbursementApplicationId}`,
      formData
    ).subscribe(result => {
      if (result) {
        this.toastr.success('Actual Amount updated successfully', 'Success');
      }
    });
  }

  onApprovalChanged(event: any) {
    if (event.colDef.field === 'approvedByManager') {
      const rowData = event.data; // pura row data
      const newValue = event.newValue; // Approved ya Rejected


      let formData = {
        "managerComment": rowData.managerComment,
        "status": (newValue == null) ? 'PENDING' : newValue,
        "managerId": parseInt(this.loggedInUserId)
      }

      this.httpService.callPutService(`${this.config.reimbursementsUpdateManager}/${rowData.reimbursementApplicationId}`, formData)
        .subscribe((result) => {
          if (result) {
            this.getAllEmployeeListing();
            this.toastr.success('Reimbursement Application  data updated by Manager Successfully', 'success');
          }
        });

    }
  }



  onApprovalChangedForHRAdmin(event: any) {
    if (event.colDef.field === 'approvedByHrAdmin') {
      const rowData = event.data; // pura row data
      const newValue = event.newValue; // Approved ya Rejected


      let formData = {
        "status": (newValue == null) ? 'PENDING' : newValue,
        hrAdminId: this.loggedInUserId
      }

      this.httpService.callPutService(`${this.config.reimbursementsUpdateHrAdmin}/${rowData.reimbursementApplicationId}`, formData)
        .subscribe((result) => {
          if (result) {
            this.getAllEmployeeListing();
            this.toastr.success('Reimbursement Application  data updated by Manager Successfully', 'success');
          }
        });

    }

  }





  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }
  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }


  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  //  approval change in detail view
  onApprovalChangedDetail(newValue: string, row: any) {
    console.log('Approval changed in detail:', newValue, row);



    const formData = {
      status: newValue,
      managerComment: row.managerComment,
      reimbursementApplicationId: row.reimbursementApplicationId,
      managerId: this.loggedInUserId
    };

    this.httpService.callPutService(`${this.config.reimbursementsUpdateManager}/${row.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {
          this.getAllEmployeeListing();
          this.toastr.success('Reimbursement Application  data updated by Manager Successfully', 'success');
        }
      });
  }


  // ✅ approval change in detail view
  onApprovalChangedDetailForHrAdmin(newValueHR: string, row: any) {
    console.log('Approval changed in detail:', newValueHR, row);



    const formData = {
      status: newValueHR,
      hrAdminId: this.loggedInUserId
    };

    this.httpService.callPutService(`${this.config.reimbursementsUpdateHrAdmin}/${row.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {

          this.getAllEmployeeListing();
          this.toastr.success('Reimbursement Application  data updated by HR Admin Successfully', 'success');
        }
      });
  }





  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE': '#126d79',
      'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN': '#3939ece8',
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800', // orange
      'REJECTED_BY_HR_ADMIN': '#f44336'
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    console.log('HR Admin Row Clicked:', event.data);
    this.selectedRow = event.data;
    console.log("selected row iss333...", this.selectedRow)
    //  this.isDetailsOpen = true;
  }
  // For HR Admin
  selectedRowForHrAdmin: any;

  onRowClickedForHRAdmin(event: any) {
    console.log('HR row click -> data:', event.data);
    this.selectedRowForHrAdmin = event.data;
    // You can decide whether show detail on row click or only on cell click
    this.isDetailsOpenForHRAdmin = true;
  }


  //Employe Login 
  onRowClickedForEmployee(event: any) {
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    if (event.colDef?.field === 'action') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  onCelledClicked(event: any) {
    console.log("field is..............", event);

    this.selectedRow = event.data;
    console.log("selected row iss...", this.selectedRow)
    // sirf managerComment ya approvedByManager pe hi details open kare
    if (event.colDef?.field === 'managerComment' || event.colDef?.field === 'approvedByManager' || event.colDef?.field === 'approvedByHrAdmin') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
      this.cdRef.detectChanges();
    }
  }
  //For Hr Admin
  isDetailsOpenForHRAdmin = false;
  onCelledClickedForHRAdmin(event: any) {
    console.log('HR cellClicked field:', event.colDef?.field, 'data:', event.data);
    this.selectedRowForHrAdmin = event.data;

    // If you want to avoid opening for certain fields (mirrors your existing logic)
    if (event.colDef?.field === 'approvedByHrAdmin') {
      this.isDetailsOpenForHRAdmin = false;
    } else {
      this.isDetailsOpenForHRAdmin = true;
      this.cdRef.detectChanges();
    }
  }

  closeDetailsForHrAdmin() {
    this.isDetailsOpenForHRAdmin = false;
  }
  // For Finance Login
  onCelledFinanceClicked(event: any) {

    this.selectedRow = event.data;

    // sirf financeComment ya assignedAmount pe hi details open kare
    if (event.colDef?.field === 'financeComment' || event.colDef?.field === 'assignedAmount' || event.colDef?.field === 'financeStatus') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      if (this.isFinanceLoginUser) {
        this.getFinaceForReimbursement(-1);
      }

      this.financeIdForEmployee = -1;
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }


  // --------------------------------AG GRID CODE---------------------------------------------------------


  removeInputs() {
    this.showInputs = false;
    this.resetFormFields();
  }
  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.rating = '';
    this.isInValidMaxRange = false;
  }


  validateInput(event: any) {
    const inputValue = event.target.value;
    // Replace multiple spaces with a single space
    event.target.value = inputValue.replace(/\s+/g, ' ');
    this.reimbursementAdd = event.target.value;
  }



  // Update Reimbursement Type
  updateReimbursementType(typeId: any) {

    // if(this.updateReimbursmentType?.length>255){
    //   this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');
    //   return;
    // }
    // ❌ Block update if too long
    if (this.updateReimbursmentType?.reimbursementType?.length > 255) {
      this.toastr.error('Maximum 255 characters allowed', 'Too Long');
      this.updateReimbursmentType.reimbursementType =
        this.updateReimbursmentType.reimbursementType.substring(0, 255);
      return;
    }

    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        this.currentreimbursementTable = result.data
        const currentreimbursementTable = result.data

        var isReimbursementTypeExist = this.currentreimbursementTable.some((elm: any) => elm.reimbursementType === this.updateReimbursmentType?.reimbursementType.trim());

        if (isReimbursementTypeExist) {
          this.toastr.error('Reimbursement type already exists', 'danger');
          return;  // Prevent further execution (i.e., saving)
        } else {
          var strReimbursementType = '';
          currentreimbursementTable.forEach((elm: any) => {
            if (elm.reimbursementId == typeId) {
              strReimbursementType = elm.reimbursementType;
            }
          });

          let isUpdated = false;

          for (const elm of currentreimbursementTable) {
            if (strReimbursementType === elm.reimbursementType) {
              this.reimbursement = {
                reimbursementId: elm.reimbursementId,
                reimbursementType: this.updateReimbursmentType?.reimbursementType,
                changedByUserId: this.loggedInUserId,
                hrAdminId: this.loggedInUserId,
                companyId: this.loggedInUserCompanyID,
                year: this.selectedYearForCompetency
              };

              this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
                .subscribe({
                  next: async (result: any) => {
                    if (!isUpdated) {
                      await this.toastr.success('Reimbursements data Updated Successfully', 'success');
                      this.resetEditingState();
                      isUpdated = true; // ✅ toastr ab dobara nahi chalega
                    }
                  },
                  error: async (err: any) => {
                    await this.toastr.error(err.error.message, 'danger');
                  }
                });
            }
          }



        }



      })


  }





  toggleInputs() {

    this.reimbursementAdd = '';
    this.reimbursementIDforEdit = '';
    this.showInputs = !this.showInputs;
  }


  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  errMsgMaxRange: boolean = false;
  saveData() {

    if (this.reimbursementAdd?.length > 255) {
      this.toastr.error()
    }
    // Check if reimbursementType already exists in the reimbursementTable
    // Check if the reimbursementType already exists in the reimbursementTable
    const isReimbursementTypeExist = this.reimbursementTable.some((elm: any) => elm.reimbursementType === this.reimbursementAdd.trim());

    // If it exists, show an error message and prevent saving the new reimbursement type
    if (isReimbursementTypeExist) {
      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      return;  // Prevent further execution (i.e., saving)
    } else {
      this.reimbursementTable.push({
        reimbursementId: null, // Use the selected reimbursementId for each band
        reimbursementType: this.reimbursementAdd, // Use the selected reimbursementType
        band: null,
        amountLimit: null
      });

      // If it does not exist, proceed to save the new reimbursement type
      this.saveNewReimbursement();


    }



    // Reset the input fields and hide the input section
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
    this.reimbursement = '';
    this.showInputs = false;
  }



  clearInputs() {
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
    this.reimbursementAdd = ""
  }



  editRow(index: number) {
    const entry = this.tableData[index];
    this.scoreRange = entry.scoreRange;
    this.maxRange = entry.maxRange;
    this.rating = entry.rating;
    this.editIndex = index;
    this.showInputs = true;
  }

  deleteRow(index: number) {
    this.tableData.splice(index, 1);
    this.reimbursementTable.splice(index, 1);

    this.clearInputs();
  }

  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/expense']);

  }


  setup() {
    this.setupForm = true;
  }
  isReimbursementInvalid(item: any): boolean {


    const invalid = this.bandListData.some(
      (band: any) => band.reimbursementId === null
    );
    console.log(`Checking item:`, item, `Result:`, invalid); // Debugging
    return invalid;
  }





  // *****************Get  competeny year***********
  isReimbursementType = false;


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      this.pmsYears = formatYearRanges(data?.data?.yearRanges)
        ?.filter((item: any) => {
          const year = parseInt(item.year?.split('-')[0], 10);
          return year <= new Date().getFullYear();
        }) || [];

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);

    });
  }
  setSelectedYear(yearValue: string): void {

    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);

    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;

      this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year
      this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year
      this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year
      this.selectedYearForGraphSix = selectedYearObj?.year
      this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year
      this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

    }
    console.log("------ this.getallReimbursementsForId()- 1--");
    this.getallReimbursementsForId();
    this.getallReimbursements();
    this.getAllEmployeesByDept();
    this.getAllUserDD();
  }
  /********************************** */

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


    //  Reset dropdown selection to "Select All Employee"
    if (this.employeeDropdown) {
      this.employeeDropdown.writeValue(-1);
    }

    //  Reset table to full list (remove filtered employee data)
    this.allTeamReimbursement = this.currrentTableDataDetails;
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/expense', { operation: operation }]);
    this.getallReimbursements();

  }

  getIndividualBandList: any = [];
  ScoreToFinalScoreConverterPlusCompanyScore: any = [];
  isInValidMaxIndividualKpi = false;
  isInValidMinIndividualKpi = false;
  isInValidMaxIndividualCompetency = false
  isInValidMinIndividualCompetency = false
  IsIndividualTotalWeightage = false
  InvalidIndividualCompetencyMaxTW = false;
  InvalidIndividualCompetencyMinTW = false;
  InvalidDepthKpiMaxScore = false;
  InvalidDepthKpiMinScore = false;
  InvalidcompanyKpiScoreMaxScore = false
  InvalidcompanyKpiScoreMinScore = false;
  InvalidcompanyscoreWT = false;
  editedIndividualScoreId: any | null = null;
  IncrementGridBandList: any = [];
  onCheckIconView: boolean = true;
  isFormDisabled: boolean = false;
  disableIncrementInputFormToHOD: any;
  disableIncrementInputFormToHrAdmin: any;
  reimbursementBandId: any;

  disableIncrementSetupAfterChangeYear: any

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/expense-logs', { moduleName: moduleName, id: 0 }]);
  }
  deleteReImbursement(event: any, index: number) {
    console.warn("deleteReImbursement")

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete these Reimbursement Types?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {

        this.httpService
          .callDeleteService(`${this.config.reimbursementsType}/${this.loggedInUserCompanyID}/${event}`)
          .subscribe(
            () => {
              // API call successful, even if result is empty


              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                // width: '30%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: 'Items successfully deleted.',
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });

              successdialogRef.afterClosed().subscribe(() => {
                this.deleteByReimbursementType = this.reimbursementTable.length == 1 ? false : true;

                //  this.clearReimbursementData(); // Clear data and fetch updated data
                // this.getallReimbursementsForId();
                this.getallReimbursements(); // Fetch the updated list

              });
            },
            (error: any) => {
              // Handle error case
              console.error('Deletion failed:', error);

              // Optional: Show error dialog
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                // width: '30%',
                width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
                maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
                data: {
                  msg: 'Items successfully deleted.',
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });
              this.getallReimbursements(); // Fetch the updated list
              this.getAllEmployeeListing();

            }
          );
      }


    });
  }

  // Helper function to clear reimbursement data
  clearReimbursementData() {
    this.reimbursementTable = [];
    this.reimbursementgetData = [];
    this.selectedReimbursement = '';
    this.reimbursementAdd = '';
    // Additional clearing logic if required
  }




  getScoreToFinalConverterIndividual() {

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    console.log("onReimbursementIdChange---1-", this.selectedReimbursement);
    this.onReimbursementIdChange(this.selectedReimbursement);
  }
  // onClickIndividualScoreEdit(itemId: number): void {
  //   console.log("onReimbursementIdChange---2-", this.selectedReimbursement, itemId);
  //   this.selectRowId = itemId;
  //   this.onReimbursementIdChange(this.selectedReimbursement);
  //   if (this.disableIncrementInputFormToHrAdmin == true || this.disableIncrementSetupAfterChangeYear == true) {
  //     this.editedIndividualScoreId = null;
  //     this.onCheckIconView = true;
  //     this.isFormDisabled = false
  //   } else {
  //     this.editedIndividualScoreId = itemId;
  //     this.onCheckIconView = true;
  //     this.isFormDisabled = false
  //   }


  // }


  onClickIndividualScoreEdit(itemId: string): void {
    console.log("Editing row:", itemId);
    this.selectRowId = itemId; // now it's band-grade identifier
    this.onReimbursementIdChange(this.selectedReimbursement);

    if (this.disableIncrementInputFormToHrAdmin || this.disableIncrementSetupAfterChangeYear) {
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    } else {
      this.editedIndividualScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }
  }

  fitergetAllFinanceUserDD: any = [];

  isFinanceLoginUser = false;
  getAllUserDD() {
    // http://192.168.0.97:8085/api/reimbursement/getAllEmployees/
    this.httpService.callGetService(`${this.config.getAllEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {

        this.getAllFinanceUserDD = result.data.users;

        setTimeout(() => {

          if (this.fetchFinanceReimbursements && this.getAllFinanceUserDD) {
            // Flatten fetch FinanceReimbursements if it's nested
            const flattenedReimbursements = this.fetchFinanceReimbursements.flat();

            console.log(flattenedReimbursements, "------------------------------------", this.getAllFinanceUserDD)
            // Filter users based on matching IDs
            const matchingUsers = this.getAllFinanceUserDD.filter((user: { id: number; }) =>
              flattenedReimbursements.includes(user.id)
            );
            //  matchingUsers

            const filterForFinance = matchingUsers.filter((elm: any) => elm.id == this.loggedInUserId);

            let data = filterForFinance.map((elm: any) => elm.id);

            if (data.length > 0) {
              this.isFinanceLoginUser = true;
            }
            let financeAdminVal = (data[0]) ? data[0] : 0;
            console.error("---------------getAllUserDD-------------");
            console.log("Finance Admin ID from ExpenseComponent:", financeAdminVal);

            this.sharedService.setFinanceAdminId(financeAdminVal);
            sessionStorage.setItem('financeAdminId', financeAdminVal);

          } else {
            console.error("Data is missing or undefined.");
          }
        }, 700);
      });
  }
  onSelectionChangeLimit(event: any) {

    this.selectedReimbursement = null;

    this.onSelectionChange(this.selectedReimbursement);
  }
  onSelectionChange(event: any) {


    if (this.limitType == 'Band' || this.limitType == 'Both') {
      this.bandListData = this.getBandData?.map((data: any) => ({
        band: data.band,
        grades: data.grades.map((grade: any) => ({
          grade: grade,
          limit: null
        })),
        companyKpiScore: null,
        reimbursementId: null,
        location: null,
        limit: null,

      }));
    } else if (this.limitType == 'Location') {
      this.bandListData = this.getLocationData?.map((data: any) => ({
        band: null,
        grades: null,

        companyKpiScore: null,
        reimbursementId: null,
        location: data,
        limit: null
      }));
    }
    else {
      this.bandListData = [
        {
          band: null,
          grades: null,
          companyKpiScore: null,
          reimbursementId: null,
          location: null,
          limit: null
        }
      ];
    }



  }

  reimbursmentIDForNo: any = [];
  onSelectionChangeForWantLimit(value: any): void {


    if (value === 'no') {

      // Validate `approveMatrix` and `selectedEmployee`
      if (!this.approveMatrix) {
        this.toastr.error("Approve matrix is required", 'danger');

        this.revertSelection();
        return;
      }

      if (this.selectedEmployee.length == 0) {
        this.toastr.error("Finance Admin is required", 'danger');
        this.revertSelection();
        return;
      }


    }

    if (value === 'yes') {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        // width: '30%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: `Are you sure you want to select "${value}"?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.wantLimit = value;
        } else {
          this.revertSelection();
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        // width: '30%',
        width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          msg: `Are you sure you want to select "${value}"?`,
          btn2: 'Save',
          btn1: 'Cancel',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.wantLimit = value;

          this.reimbursmentIDForNo = this.reimbursementTable.map((elm: any) => ({
            reimbursementId: elm.reimbursementId,
            financeAccessEmployeeIds: this.selectedEmployee,
            approvedMatrix: this.approveMatrix,
            year: this.selectedYearForCompetency,
            companyId: this.loggedInUserCompanyID,
            fiscal_year: this.loggedInCompanyFiscalyear,
            setLimit: false,
          }));

          this.reimbursmentIDForNo.forEach((element: any) => {
            this.httpService
              .callPutService(`${this.config.updreimbursement}`, element)
              .subscribe({

                next: async (result: any) => {
                  await this.toastr.success(result.message, 'success');
                  this.getallReimbursements();
                  this.resetEditingState();
                  this.wantLimit = 'no';
                  this.isLimitTypeLocked = true;
                },
                error: async (err: any) => {
                  await this.toastr.error(err.error.message, 'danger');
                },
              });
          });


        } else {
          this.revertSelection();
        }
      });
    }
  }

  private revertSelection(): void {
    // Reset the `wantLimit` to its previous value
    setTimeout(() => {
      this.wantLimit = ''; // Ensure the UI reflects the reset value
    });
  }

  individualRowData: any;
  checkrowGrade: any
  IndividualTotalWeightage(item: any, grade: any) {
    this.checkrowGrade = grade;
    this.individualRowData = item;


  }

  getAllBand() {
    // this.httpService.callGetService(`${this.config.getBandsByCompanyForSetUP}/${this.loggedInUserCompanyID}`)
    this.httpService.callGetService(`${this.config.getBandAndGradeForProbation}?companyId=${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.getBandData = result.data;
        this.bandRecord = result.data;
      });
  }

  getAllLocation() {
    this.httpService.callGetService(`${this.config.getWorkLocationStateByCompany}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.getLocationData = result.data;

      });
  }
  editReImbursement(event: any, i: any) {
    this.EditData = true;
    this.editableIndex = i;
    this.reimbursementIDforEdit = event.reimbursementId;


  }
  closeEditing(): void {

    this.deleteByReimbursementType = this.reimbursementTable.length == 0 ? false : true;
    this.resetEditingState();
    this.getallReimbursements();
  }
  resetEditingState(): void {
    this.showInputs = false;
    this.EditData = false;
    this.editableIndex = null;
  }

  handleReimbursementClick(limitType: any, reimbursementId: any, i: any, check: any): void {


    if (limitType == null) {
      this.toastr.error("Limit value is required", 'Error');
      return;
    }

    if (i == 0) {
      console.log(limitType);

      // Call update-save function if reimbursementAddId exists
      (limitType) ? this.updatesaveReimbursement() : this.saveReimbursement();

    } else if (reimbursementId !== null && check !== null) {
      // Call update function if item.reimbursementId exists
      console.log("-----updateReimbursement--------")
      this.updateReimbursement();
    } else {
      // Call save function if neither exists
      console.log("-----saveReimbursement--------")
      this.saveReimbursement();
    }
  }
  onClickIndividualScoreEdit1(itemId: any): void {
    console.log("onReimbursementIdChange---2-", this.selectedReimbursement, itemId);
    this.selectRowId = itemId;
    this.onReimbursementIdChange(this.selectedReimbursement);
    if (this.disableIncrementInputFormToHrAdmin == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    } else {
      this.editedIndividualScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false
    }


  }

  saveReimbursement() {

    if (!this.approveMatrix) {
      this.toastr.error("Approve matrix is required", 'Error');
      return;
    } else if (this.selectedEmployee == 0) {
      this.toastr.error("Finance admin is required", 'Error');
      return;
    }

    if (!this.individualRowData) {
      this.toastr.error("Please enter the value.", 'Error');
      return;
    }

    const remData = this.reimbursementTable.filter((elm: any) => elm.reimbursementId == this.selectedReimbursement);
    console.log(this.individualRowData);
    let checkgradeAndLimit = this.individualRowData?.grades?.filter((e: any) => (e.limit !== null && e.limit != '' && e.reimbursementId == null) || e.limit == 0)

    console.log(checkgradeAndLimit);

    let formData = {
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),
      "reimbursementType": remData[0]?.reimbursementType,
      "setLimit": true,
      "limitType": this.limitType,
      // "reimbursementId": this.individualRowData.reimbursementId,
      "band": this.individualRowData?.band,
      "grade": (checkgradeAndLimit && checkgradeAndLimit[0]?.limit) ? checkgradeAndLimit[0]?.grade : null,
      "location": this.individualRowData.location ? this.individualRowData.location : null,
      // "amountLimit": this.individualRowData.limit ? this.individualRowData.limit : (this.individualRowData.limit == 0) ? 0 : null,
      "amountLimit": (checkgradeAndLimit && checkgradeAndLimit[0]?.limit) ? checkgradeAndLimit[0]?.limit : this.individualRowData?.limit ? this.individualRowData?.limit : (checkgradeAndLimit[0]?.limit == 0) ? 0 : (this.individualRowData?.limit == 0) ? 0 : null,
      "approvedMatrix": this.approveMatrix,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,
    }
    console.log(formData);


    this.httpService.callPostService(`${this.config.reimbursement}`, formData)
      .subscribe({
        next: async (result: any) => {
          await this.toastr.success(result.message, 'success');
          this.getallReimbursements();
          // this.getCompetencySetup();

        },
        error: async (err: any) => {

          await this.toastr.error(err.error.message, 'Error');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

  }


  updatesaveReimbursement() {
    console.log("ffffffff--------------------")
    if (!this.approveMatrix) {
      this.toastr.error("Approve matrix is required", 'Error');
      return;
    }
    if (this.selectedEmployee.length === 0) {
      this.toastr.error("Finance admin is required", 'Error');
      return;
    }

    const remData = this.reimbursementTable.filter((elm: any) => elm.reimbursementId == this.selectedReimbursement);
    console.log(this.individualRowData);
    // let checkgradeAndLimit=this.individualRowData.grades.filter((e:any)=>e.limit!==null&&e.limit!='')
    let checkgradeAndLimit = this.individualRowData?.grades?.filter((e: any) => (e.limit !== null && e.limit != '' && e.reimbursementId == null) || e.limit == 0)
    console.log(checkgradeAndLimit);

    let formData = {
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),
      "reimbursementType": remData[0]?.reimbursementType,
      "setLimit": true,
      "reimbursementId": this.selectedReimbursement,
      "band": (this.individualRowData == undefined) ? null : this.individualRowData?.band,
      "grade": checkgradeAndLimit?.limit ? checkgradeAndLimit[0]?.grade : null,
      "location": this.individualRowData?.location ? this.individualRowData?.location : null,
      "amountLimit": checkgradeAndLimit?.limit ? checkgradeAndLimit[0]?.limit : this.individualRowData?.limit ? this.individualRowData?.limit : (checkgradeAndLimit[0]?.limit == 0) ? 0 : (this.individualRowData?.limit == 0) ? 0 : null,
      "approvedMatrix": this.approveMatrix,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "limitType": this.limitType,
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,

    }
    console.log(formData);


    this.httpService.callPutService(`${this.config.updreimbursement}`, formData)
      .subscribe({
        next: async (result: any) => {

          await this.toastr.success(result.message, 'success');
          this.getallReimbursements();


        },
        error: async (err: any) => {

          await this.toastr.error(err.error.message, 'Error');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

  }


  confirmSelection(item: any, event: Event): void {
    this.toastShown = false; // Reset toast flag each time user makes a selection

    this.reimbursmentIDForNo = this.reimbursementTable.map((elm: any) => ({
      reimbursementId: elm.reimbursementId,
      financeAccessEmployeeIds: this.selectedEmployee,
      approvedMatrix: this.approveMatrix,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      changedByUserId: this.loggedInUserId,
      hrAdminId: this.loggedInUserId
    }));

    const isAlreadySelected = this.selectedEmployee.includes(item.id);

    if (!this.selectedFinanceEmployee.includes(item.id)) {
      this.selectedFinanceEmployee.push(item.id);
    }

    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: isAlreadySelected
          ? 'Do you really want to select this Finance Admin?'
          : 'Do you really want to unselect this Finance Admin?',
        btn1: 'No',
        btn2: 'Yes',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        if (!this.selectedEmployee.includes(item.id)) {
          this.selectedEmployee.push(item.id);
        }

        if (this.allreadySellectedFinanceAdmin.length) {
          this.reimbursmentIDForNo.forEach((element: any, index: number) => {
            this.httpService.callPutService(`${this.config.updateReimbursement}`, element)
              .subscribe({
                next: async (res: any) => {
                  if (!this.toastShown) {
                    this.toastShown = true; // Show toast only once
                    this.toastr.success(res.message, 'Success');
                  }

                  if (index === this.reimbursmentIDForNo.length - 1) {
                    this.getallReimbursements();
                    this.resetEditingState();
                  }
                },
                error: async (err: any) => {
                  this.toastr.error(err.error.message || 'Update failed', 'Error');
                },
              });
          });
        }

      } else if (result === false && !isAlreadySelected) {
        this.selectedEmployee = this.selectedFinanceEmployee;
      } else {
        this.selectedEmployee = this.selectedEmployee.filter((id: any) => id !== item.id);
      }

      this.cdRef.detectChanges();
    });
  }


  reimbursementsArray: { reimbursementId: number, reimbursementType: string }[] = [];

  saveNewReimbursement() {


    this.reimbursement = {
      // "reimbursementType": this.reimbursementAdd,
      "reimbursementId": this.reimbursementIDforEdit || null,
      "reimbursementType": this.reimbursementAdd.trim() || this.updateReimbursmentType.reimbursementType.trim(),
      "year": this.selectedYearForCompetency,
      "fiscal_year": this.loggedInCompanyFiscalyear,
      "companyId": this.loggedInUserCompanyID,
      "hrAdminId": parseInt(this.loggedInUserId),

    }

    // return;
    this.httpService.callPostService(`${this.config.onlyreimbursementType}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {
          await this.toastr.success(result.message, 'success');

          this.reimbursementAddId = result.data.reimbursementId;


          this.reimbursementBandId = result.data.reimbursementId;
          if (result.status && result.data) {
            this.reimbursementsArray.push({
              reimbursementId: result.data.reimbursementId,
              reimbursementType: result.data.reimbursementType,
            });

            if (this.wantLimit == 'no') {
              const UpdateData = {
                reimbursementId: this.reimbursementAddId,
                financeAccessEmployeeIds: this.selectedEmployee,
                approvedMatrix: this.approveMatrix,
                year: this.selectedYearForCompetency,
                fiscal_year: this.loggedInCompanyFiscalyear,
                setLimit: false,
              }

              this.httpService
                .callPutService(`${this.config.updreimbursement}`, UpdateData)
                .subscribe({
                  next: async (result: any) => {
                    await this.toastr.success(result.message, 'success');
                    this.getallReimbursements();
                    this.resetEditingState();
                    this.wantLimit = 'no';
                    this.isLimitTypeLocked = true;
                  },
                  error: async (err: any) => {
                    await this.toastr.error(err.error.message, 'Error');
                  },
                });



            }
            console.log("------ this.getallReimbursementsForId()- 2--");
            this.getallReimbursementsForId();
          }

        },
        error: async (err: any) => {

          await this.toastr.error(err.error.message, 'Error');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    this.resetEditingState();

  }
  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }

  getallReimbursementsForIdforType() {
    // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => { })
  }

  fetchFinanceReimbursements: any = [];
  currentreimbursementTable: any = [];

  getallReimbursementsForId() {
    // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        const getData = result.data[0];

        this.currentreimbursementTable = result?.data
        this.selectedReimbursement = getData?.reimbursementId;
        console.log("***********this.selectedReimbursement***--", this.selectedReimbursement)
        if (this.limitType == 'Band' || this.limitType == 'Both') {

          this.reimbursementgetData = result.data.filter((elm: any) => elm.band != null);
          this.reimbursementTable = result?.data
            .filter((elm: any) => elm)
            .reduce((acc: any[], current: any) => {
              if (!acc.some((item) => item.reimbursementType === current.reimbursementType)) {
                acc.push(current);
              }
              return acc;
            }, []);
        } else if (this.limitType == 'Location') {
          this.reimbursementgetData = result?.data.filter((elm: any) => elm.location != null);
          this.reimbursementTable = result?.data
            .filter((elm: any) => elm)
            .reduce((acc: any[], current: any) => {
              if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                acc.push(current);
              }
              return acc;
            }, []);
        } else {
          this.reimbursementgetData = result?.data.filter((elm: any) => elm.location == null && elm.band == null);

          this.reimbursementTable = result?.data.filter((elm: any) => elm.location == null && elm.band == null);
        }
      })
  }
  handalemployeToFinanceCondition: any = []
  getallReimbursements() {
    console.log("------------getallReimbursements()----");

    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      // this.httpService.callGetService(`${this.config.viewAllReimbursements}/${this.selectedYearForCompetency}`)
      .subscribe({
        next: (result: any) => {

          let arrAllReimbursement = result.data.filter((elm: any) => elm.setLimit === true);
          let arrAllReimbursementForFalse = result.data.filter((elm: any) => elm.setLimit === false);


          this.handalemployeToFinanceCondition = (arrAllReimbursement[0]?.approvedMatrix) ? arrAllReimbursement[0]?.approvedMatrix : result?.data[0]?.approvedMatrix;
          console.log("qqqq............", this.handalemployeToFinanceCondition)
          let approvedMatrix = result.data.filter((elm: any) => elm.approvedMatrix);



          this.approveMatrixValueForCondition = this.handalemployeToFinanceCondition;

          this.httpService.passApprovematrixForReport = this.approveMatrixValueForCondition;

          this.empReimbursementTable();

          if (result.data.length > 0) {

            if (arrAllReimbursement.length > 0) {
              this.wantLimit = 'yes';
              this.isLimitTypeLocked = true;
            } else if (arrAllReimbursementForFalse.length > 0) {
              this.wantLimit = 'no';
              this.approveMatrix = this.handalemployeToFinanceCondition;
              this.isLimitTypeLocked = true;

            }

          } else {
            this.wantLimit = '';
            this.limitType = '';
            this.approveMatrix = '';
            this.isLimitTypeLocked = false;
            this.selectedReimbursement = null;
          }
          // this.reimbursementTable=[];

          /*     if (result.data[0]?.band == null && result.data[0]?.location == null && (result.data[0]?.limitType != 'Neither' || result.data[0]?.limitType != 'band' || result.data[0]?.limitType != 'location')) {
                this.reimbursementAddId = result.data[0]?.reimbursementId;
              } */

          this.reimbursementgetData = [];
          if (result.data[0]?.band == null && result.data[0]?.location == null && result.data[0]?.limitType == 'Neither') {


            this.reimbursementAddId = result.data[0]?.reimbursementId;

            const getData = result.data[0];

            this.approveMatrix = this.handalemployeToFinanceCondition;
            this.selectedEmployee = arrAllReimbursement[0]?.financeAccessEmployeeIds || [];
            this.limitType = arrAllReimbursement[0]?.limitType,
              this.httpService.limitTypes = this.limitType;
          } else if (arrAllReimbursement[0]?.band != null || arrAllReimbursement[0]?.location != null) {

            const getData = result.data[0]; // This is the first item in the array
            this.approveMatrix = this.handalemployeToFinanceCondition;
            this.selectedEmployee = arrAllReimbursement[0]?.financeAccessEmployeeIds || [];
            this.limitType = arrAllReimbursement[0]?.limitType
            this.httpService.limitTypes = this.limitType;
          }
          else if (arrAllReimbursementForFalse[0]?.setLimit == false) {
            this.approveMatrix = this.handalemployeToFinanceCondition;
          } else {
            this.reimbursementAddId = result.data[0]?.reimbursementId;
          }

          // this.selectedReimbursement = getData?.reimbursementType;

          if (!this.deleteByReimbursementType) {

            const financeAdmin = result?.data.map((elm: any) => elm.financeAccessEmployeeIds);
            this.financeAdmindb = result?.data.map((elm: any) => elm.financeAccessEmployeeIds);
            this.allreadySellectedFinanceAdmin = this.financeAdmindb.flat();

            this.selectedEmployee = financeAdmin.flat();


            this.selectedEmployee = [...new Set(financeAdmin.flat())]; // Remove duplicates using Set
          }

          // Check if already present in fetchFinanceReimbursements to avoid duplicate pushes
          if (!this.fetchFinanceReimbursements.some((item: any) => JSON.stringify(item) === JSON.stringify(this.selectedEmployee))) {
            this.fetchFinanceReimbursements.push(this.selectedEmployee);
          }

          if (this.fetchFinanceReimbursements && this.getAllFinanceUserDD) {
            // Flatten fetch FinanceReimbursements if it's nested
            const flattenedReimbursements = this.fetchFinanceReimbursements.flat();

            console.log(flattenedReimbursements, "------------------------------------", this.getAllFinanceUserDD)
            // Filter users based on matching IDs
            const matchingUsers = this.getAllFinanceUserDD.filter((user: { id: number; }) =>
              flattenedReimbursements.includes(user.id)
            );
            //  matchingUsers

            const filterForFinance = matchingUsers.filter((elm: any) => elm.id == this.loggedInUserId);

            let data = filterForFinance.map((elm: any) => elm.id);

            if (data.length > 0) {
              this.isFinanceLoginUser = true;
            }
            let financeAdminVal = (data[0]) ? data[0] : 0;

            this.sharedService.setFinanceAdminId(financeAdminVal);
            sessionStorage.setItem('financeAdminId', financeAdminVal);


          }


          this.onSelectionChange(this.limitType);

          if (this.limitType == 'Band' || this.limitType == 'Both') {

            this.reimbursementgetData = result.data;
            // this.reimbursementgetData = result.data.filter((elm: any) => elm.band != null );

            this.reimbursementTable = result.data
              .filter((elm: any) => elm)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);


            this.onReimbursementIdChange(this.selectedReimbursement);
          } else if (this.limitType == 'Location') {

            this.reimbursementgetData = result?.data.filter((elm: any) => elm);

            this.reimbursementTable = result?.data
              .filter((elm: any) => elm)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);
            console.log("onReimbursementIdChange---4-", this.selectedReimbursement);
            this.onReimbursementIdChange(this.selectedReimbursement);
          } else {
            this.reimbursementgetData = result?.data.filter((elm: any) => elm);

            // this.reimbursementTable = result?.data.filter((elm: any) => elm.location == null && elm.band == null);
            this.reimbursementTable = result?.data
              .filter((elm: any) => elm.location == null && elm.band == null)
              .reduce((acc: any[], current: any) => {
                if (!acc.some((item) => item?.reimbursementType === current.reimbursementType)) {
                  acc.push(current);
                }
                return acc;
              }, []);
            console.log("onReimbursementIdChange---5-", this.selectedReimbursement);
            this.onReimbursementIdChange(this.selectedReimbursement);
          }


          this.getAllEmployeeListing();

        },
        error: (err) => {
          console.error("Error fetching reimbursement data:", err);
        }

      });

  }

  selectedReimbursementPID: any;
  onReimbursementIdChange(selectedId: any) {
    // Reset edit mode when reimbursement changes
    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    // this.isFormDisabled = true;

    console.log("onReimbursementIdChange", selectedId);

    // Reset reimbursementAddId for certain limitTypes
    if (['Location', 'Band', 'Both'].includes(this.limitType)) {
      this.reimbursementAddId = '';
    }

    this.editReimbursemendData = true;

    const remData = this.reimbursementTable.filter(
      (elm: any) => elm.reimbursementId == selectedId
    );

    if (!remData.length) return;

    const findBandAndReimbursement = this.reimbursementgetData.filter(
      (item: any) => item?.reimbursementType === remData[0]?.reimbursementType
    );

    if (!findBandAndReimbursement.length) return;

    // Map over bandListData to update limits
    const updatedBandListData = this.bandListData?.map((bandData: any) => {
      const updatedBand = { ...bandData };

      // Update each grade individually
      updatedBand.grades = bandData?.grades?.map((gradeItem: any) => {
        const matchingGrade = findBandAndReimbursement.find(
          (data: any) => data.band === bandData.band && data.grade === gradeItem.grade
        );

        return {
          ...gradeItem,
          check: matchingGrade ? matchingGrade.amountLimit : null,
          limit: matchingGrade ? matchingGrade.amountLimit : null,
          reimbursementId: matchingGrade ? matchingGrade.reimbursementId : null,
        };
      });

      // Update band-level fields if needed
      const matchingBand = findBandAndReimbursement.find(
        (data: any) => data.band === bandData.band
      );
      updatedBand.selectedEmployee = matchingBand ? matchingBand.financeAccessEmployeeIds : null;
      updatedBand.reimbursementId = matchingBand ? matchingBand.reimbursementId : null;
      updatedBand.limit = matchingBand ? matchingBand.amountLimit : null;
      updatedBand.location = matchingBand ? matchingBand.location : bandData.location;

      return updatedBand;
    });

    // Assign updated data depending on limitType
    if (['Band', 'Both'].includes(this.limitType)) {
      this.bandListData = updatedBandListData;
    } else if (this.limitType === 'Location') {
      // For location-based limits, filter by location
      console.log("hello-------------");

      this.bandListData = this.bandListData?.map((band: any) => {
        const matchingLoc = findBandAndReimbursement.find(
          (data: any) => data.location === band.location
        );
        return {
          ...band,
          limit: matchingLoc ? matchingLoc.amountLimit : null,
          reimbursementId: matchingLoc ? matchingLoc.reimbursementId : null,
        };
      });
    } else {
      // Case for neither Band nor Location
      this.bandListData = updatedBandListData.map((band: any) => {
        const matching = findBandAndReimbursement.find(
          (data: any) => !data.band && !data.location && data.amountLimit != null
        );
        return {
          ...band,
          limit: matching ? matching.amountLimit : null,
          reimbursementId: matching ? matching.reimbursementId : null,
        };
      });
    }

    console.log("Updated bandListData:", this.bandListData);
  }



  allreadySellectedFinanceAdmin: any = [];
  financeAdmindb: any = [];
  updateBandListData(allData: any, Reimbursements: any, bandlistdata: any[]) {


    if (Reimbursements.length > 0) {
      const updatedBandListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.band === bandData.band);

        // Update the limit for the matching band or set it to null for non-matching bands

        return {
          ...bandData,
          selectedEmployee: matchingBand ? matchingBand.financeAccessEmployeeIds : null,
          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedLocationListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.location === bandData.location);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });

      const updatedNeitherListData = bandlistdata.map((bandData: any) => {
        // Find the corresponding entry for the current band in allData
        const matchingBand = Reimbursements.find((data: any) => data.location === null && data.band === null);
        // Update the limit for the matching band or set it to null for non-matching bands
        return {
          ...bandData,

          reimbursementId: matchingBand ? matchingBand.reimbursementId : null,
          limit: matchingBand ? matchingBand.amountLimit : null, // Use amountLimit if matching, otherwise null
        };
      });
      // Case when limitType is 'Band' and selectedReimbursement has amountLimit
      if ((this.limitType === 'Band' || this.limitType === 'Both') && Reimbursements.amountLimit !== null) {
        this.bandListData = updatedBandListData;
        console.log(this.bandListData);

      }

      else if (this.limitType === 'Location' && Reimbursements.amountLimit !== null) {
        this.bandListData = updatedLocationListData;
      } else {
        this.bandListData = updatedNeitherListData
        // Case when reimbursementId is null, handle accordingly

      }

    }


  }

  updateReimbursmentType: any;
  updateSpecificreimbursmentType(event: any) {
    this.updateReimbursmentType = event;
  }

  updateReimbursement() {
    console.log(this.individualRowData);
    // let checkgradeAndLimit=this.individualRowData.grades.filter((e:any)=>e.limit!==null&&e.limit!='')
    let checkgradeAndLimit = this.individualRowData?.grades?.filter((e: any) => (e.limit !== null && e.limit != ''
      && e.grade == this.checkrowGrade) || e.limit == 0)

    if (this.individualRowData == undefined) {
      this.toastr.success('Reimbursements data Updated Successfully', 'success');
      return;
    }

    console.log(checkgradeAndLimit);

    this.reimbursement = {
      "amountLimit": (checkgradeAndLimit && checkgradeAndLimit[0]?.limit) ? checkgradeAndLimit[0]?.limit : this.individualRowData?.limit ? this.individualRowData?.limit : (checkgradeAndLimit[0] == 0) ? 0 : (this.individualRowData?.limit == 0) ? 0 : null,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "reimbursementId": (checkgradeAndLimit && checkgradeAndLimit[0]?.reimbursementId) ? checkgradeAndLimit[0]?.reimbursementId : this.individualRowData?.reimbursementId || this.reimbursementIDforEdit || this.bandListData[0].reimbursementId,
      "reimbursementType": this.updateReimbursmentType?.reimbursementType ? this.updateReimbursmentType?.reimbursementType : null,
      "changedByUserId": this.loggedInUserId,
      "hrAdminId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYearForCompetency
    }


    this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {


          await this.toastr.success(result.message, 'success');
          this.getallReimbursements();
          this.resetEditingState()
        },
        error: async (err: any) => {


          await this.toastr.error(err.error.message, 'Error');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  updateReimbursementForNo() {

    this.reimbursement = {
      "amountLimit": this.individualRowData?.limit ? this.individualRowData?.limit : null,
      "financeAccessEmployeeIds": this.selectedEmployee,
      "reimbursementId": this.individualRowData?.reimbursementId || this.reimbursementIDforEdit || this.bandListData[0].reimbursementId,
      "reimbursementType": this.updateReimbursmentType?.reimbursementType ? this.updateReimbursmentType?.reimbursementType : null,
      "changedByUserId": this.loggedInUserId,
      "hrAdminId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPutService(`${this.config.updateReimbursement}`, this.reimbursement)
      .subscribe({
        next: async (result: any) => {


          await this.toastr.success(result.message, 'success');
          this.getallReimbursements();
          this.resetEditingState()
        },
        error: async (err: any) => {


          await this.toastr.error(err.error.message, 'Error');
        }
      });

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }
  // Year 

  getYearSetupForReimbursement() {
    this.httpService.callGetService(`${this.config.getYearSetupForReimbursement}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        const selectedYear = this.selectedYearForCompetency.split('-')[0];


        if (elm.data.length > 0) {
          console.log("------ this.getallReimbursementsForId()- 3--");
          this.getallReimbursementsForId();
          this.getallReimbursements();
          // this.onReimbursementIdChange('oo');

        } else {

          this.isLimitTypeLocked = false;
          this.approveMatrix = '';
          this.wantLimit = '';
          this.limitType = '';
          this.selectedReimbursement = '';
          this.selectedEmployee = [];
          this.bandListData = [];
          this.reimbursementTable = []
        }

        if (selectedYear != new Date().getFullYear()) {


          this.isReimbursementType = true;
          this.isLimitTypeLocked = true;
        } else {
          this.isReimbursementType = false;
        }

      })


  }


  // ---------------------------------Employee Login -------------------------------------------
  taskColumnHeaderInfo: any[] = [];

  taskColumnHeaderInfoForManager: any[] = [];
  taskColumnHeaderInfoForHrAdmin: any[] = [];
  taskColumnHeaderInfoForFinanse: any = [];
  taskColumnHeaderInfoForFinanceHRAdmin: any = [];
  empReimbursementTable() {
    const commonColumns = [
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1,           // ✅ ek condition
          browserDatePicker: true,       // ✅ sirf date picker
        }
      }, {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 240, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 170, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount By Finance', isMandatory: true, minWidth: 250, filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      },
      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      },
      {
        headerName: 'Action',
        field: 'action',
        minWidth: 150,
        filter: false,
        cellRenderer: (params: any) => {
          if (
            (params.data.approvedByManager !== 'APPROVED' && params.data.approvedByManager !== 'REJECTED') &&
            (params.data.approvedStatus !== 'APPROVED' && params.data.approvedStatus !== 'REJECTED')
          ) {
            return `
            <span class="material-icons cp" data-action="edit" style="color:#ff9800;cursor:pointer;margin-right:8px;">edit</span>
            <span class="material-icons cp" data-action="delete" style="color:#e53935;cursor:pointer;">delete</span>
          `;
          }
          return '';
        },
        onCellClicked: (params: any) => {
          if (!params.event.target) return;
          const action = params.event.target.getAttribute('data-action');
          if (action === 'edit') {
            params.context.componentParent.addKPISPopup(params.data);
          }
          if (action === 'delete') {
            params.context.componentParent.deleteEmployee(params.data.reimbursementApplicationId);
          }
        }
      }



      ,
    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,

        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },

        // ✅ Validation: 250 chars max
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },

        onCellClicked: (params: any) => {
          if (params.value) {
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };

      const employeeCommentIndex = commonColumns.findIndex(
        column => column.field === 'employeeComment'
      );
      commonColumns.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }


    this.taskColumnHeaderInfo = commonColumns;
    // For manager ...

    const taskColumnHeaderInfoForManager = [
      { headerName: 'Employee Name', isMandatory: true, minWidth: 180, filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      // { headerName: 'Reimbursement Id', isMandatory: true,minWidth: 220 , filter: 'agSetColumnFilter',  field: 'reimbursementId' },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 170, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount by Finance', isMandatory: true, minWidth: 240, filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        editable: (params: any) => {
          // ✅ Editable tabhi hoga jab approval PENDING ho
          return false;
        },
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        editable: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 200,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      },
      {
        headerName: 'Approval',
        field: 'approvedByManager',
        minWidth: 150,

        editable: (params: any) => {
          // compute whether editable (example: editable only when value is missing or PENDING)
          const isEditable = params && params.data &&
            (params.data.financeStatus === null || params.data.financeStatus === undefined || params.data.financeStatus === 'PENDING');

          console.log('editable?', isEditable, 'value=', params.value, 'data=', params.data);
          return isEditable; // <- IMPORTANT: return boolean
        },
        cellEditorSelector: (params: any) => {
          if (!params.value || params.value === 'PENDING') {
            return {
              component: 'agSelectCellEditor',
              params: {
                values: ['APPROVED', 'REJECTED']
              }
            };
          }
          return null; // ✅ disable editor if Approved/Rejected
        },
        cellRenderer: (params: any) => {
          const value = params.value || 'PENDING';
          let color = '#999';

          if (value === 'APPROVED') color = '#4caf50';
          else if (value === 'REJECTED') color = '#f44336';

          const pointer = (value === 'PENDING') ? 'pointer' : 'not-allowed';

          return `
            <span style="
              border: 1px solid ${color};
              color: ${color};
              background: ${color}15;
              cursor: ${pointer};
              padding: 3px 8px;
              line-height: 1.4em;
              border-radius: 12px;
              font-size: 12px;
              font-weight: 500;
              display: inline-block;
            ">
              ${value}
              ${(value === 'PENDING') ? '<span style="font-size:10px; margin-left:6px; color:' + color + '">▼</span>' : ''}
            </span>
          `;
        }
      }

    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        editable: (params: any) => {
          // ✅ Editable tabhi hoga jab approval PENDING ho
          return params.data.approvedByManager !== 'APPROVED' && params.data.approvedByManager !== 'REJECTED';
        },
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 200,
        cellRenderer: (params: any) => {
          if (!params.value) {
            // ✅ Agar approved/rejected hai to message greyed-out dikhayenge
            if (params.data.approvedByManager === 'APPROVED' || params.data.approvedByManager === 'REJECTED') {
              return '<span class="text-muted"></span>';
            }
            return '<span class="text-muted clickable-comment" style="cursor:pointer;color:#aaa;">Click to add comment</span>';
          }

          const shortText =
            params.value?.length > 30 ? params.value.substring(0, 30) + '...' : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        // ✅ Validation: 250 chars max
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },
        onCellClicked: (params: any) => {
          // ✅ Agar Approved/Rejected hai to kuch mat karo
          if (params.data.approvedByManager === 'APPROVED' || params.data.approvedByManager === 'REJECTED') {
            return;
          }
          // ✅ Abhi grid ke sabhi editing cells check karo
          const editingCells = params.api.getEditingCells();

          const isEditing = editingCells.some(
            (cell: any) => cell.rowIndex === params.rowIndex && cell.column.getId() === params.column.getId()
          );

          if (isEditing) {
            return; // agar edit mode me hai to kuch mat karo
          }

          // ✅ Sirf tab modal open hoga jab user cell edit nahi kar raha hai
          if (params.value) {
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }

      };

      const employeeCommentIndex = taskColumnHeaderInfoForManager.findIndex(
        column => column.field === 'employeeComment'
      );
      taskColumnHeaderInfoForManager.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }


    this.taskColumnHeaderInfoForManager = taskColumnHeaderInfoForManager;



    // --------------------------For HR Admin--------------------------

    const taskColumnHeaderInfoForHrAdmin = [
      { headerName: 'Employee Name', isMandatory: true, minWidth: 180, filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (a: any, b: any) => this.dateComparator(a, b),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: { filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true, maxNumConditions: 1 }
      },
      {
        headerName: 'Date of Expense',
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (a: any, b: any) => this.dateComparator(a, b),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: { filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true, maxNumConditions: 1 }
      },
      { headerName: 'Limit of Reimbursement', minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', minWidth: 170, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Attachment', field: 'uploadDocument', cellRenderer: (p: any) => this.downloadRenderer(p), filter: false, minWidth: 135 },

      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true,
        cellStyle: { whiteSpace: 'normal' }
      },

      // 🔹 HR Admin Comment Column


      // 🔹 HR Admin Approval Column
      {
        headerName: 'Approval',
        field: 'approvedByHrAdmin',
        minWidth: 150,
        // editable: (params: any) => params.data.approvedByHrAdmin === 'PENDING',
        editable: (params: any) => {
          // compute whether editable (example: editable only when value is missing or PENDING)
          const isEditable = params && params.data &&
            (params.data.approvedByHrAdmin === null || params.data.approvedByHrAdmin === undefined || params.data.approvedByHrAdmin === 'PENDING');

          console.log('editable?', isEditable, 'value=', params.value, 'data=', params.data);
          return isEditable; // <- IMPORTANT: return boolean
        },
        cellEditorSelector: (params: any) => {
          if (!params.value || params.value === 'PENDING') {
            return { component: 'agSelectCellEditor', params: { values: ['APPROVED', 'REJECTED'] } };
          }
          return null;
        },

        cellRenderer: (params: any) => {
          const value = params.value || 'PENDING';
          const color = value === 'APPROVED' ? '#4caf50' : (value === 'REJECTED' ? '#f44336' : '#999');
          return `
        <span style="
          border:1px solid ${color};
          color:${color};
          background:${color}15;
          border-radius:12px;
          font-size:12px;
          font-weight:500;
          padding:3px 8px;
           min-height:28px;
             line-height:1.4em;
              vertical-align:middle;
          display:inline-block;
        ">
          ${value}
          ${value === 'PENDING' ? '<span style="font-size:10px;margin-left:6px;color:' + color + '">▼</span>' : ''}
        </span>
      `;
        }
      }
    ];

    console.log("HR admin  data1111111111111 .........", taskColumnHeaderInfoForHrAdmin);
    this.gridApi?.setColumnDefs(this.taskColumnHeaderInfoForHrAdmin);

    this.taskColumnHeaderInfoForHrAdmin = taskColumnHeaderInfoForHrAdmin;

    console.log("HR Admin data2222222222", this.taskColumnHeaderInfoForHrAdmin);

    // ---------------------------End HR Admin --------------------------


    // ================================== Start for the finance=========================================

    const taskColumnHeaderInfoForFinanse = [
      { headerName: 'Employee Name', isMandatory: true, minWidth: 180, filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 170, filter: 'agSetColumnFilter', field: 'actualAmount' },
      {
        headerName: 'Actual Amount by Finance',
        field: 'assignedAmount',
        minWidth: 250,
        filter: 'agSetColumnFilter',

        // Sirf tab editable jab status PENDING hai
        editable: (params: any) => {
          return params.data.financeStatus !== 'APPROVED' && params.data.financeStatus !== 'REJECTED';
        },

        // Renderer (sirf text ya greyed-out)
        cellRenderer: (params: any) => {
          const value = params.value ?? '';
          if (params.data.financeStatus === 'APPROVED' || params.data.financeStatus === 'REJECTED') {
            return `<span class="text-muted">${value || '-'}</span>`;
          }
          return `<span>${value || '<span style="color:#aaa">Click to edit</span>'}</span>`;
        },

        // Editor selector (agar Pending hai to input allow)
        cellEditorSelector: (params: any) => {
          if (params.data.financeStatus !== 'APPROVED' && params.data.financeStatus !== 'REJECTED') {
            return {
              component: 'agTextCellEditor', // ✅ AG Grid ka default input editor
              params: {
                inputType: 'number',
                maxLength: 10
              }
            };
          }
          return null; // disable editor
        },

        // Change event (jab user edit karke enter/blur kare)
        onCellValueChanged: (params: any) => {
          const newValueNum = params.newValue;
          console.log(newValueNum);

          // ✅ Validation: Allow only numbers
          if (isNaN(newValueNum)) {
            this.toastr.error('Only numeric values are allowed', 'Invalid Input');
            this.getAllEmployeeListing();
            // params.node.setDataValue('assignedAmount', params.oldValue); // old value restore
            return;
          }
          console.log("----2831--", params.oldValue);
          if (params.newValue !== params.oldValue) {


            let formData = {
              "financeComment": null,
              "approvedStatus": "PENDING",
              "assignedAmount": params.newValue,
              "financeId": parseInt(this.loggedInUserId)
            }

            this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${params.data.reimbursementApplicationId}`, formData)
              .subscribe((result) => {
                if (result) {
                  this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');
                }
              });
          }
        }
      }
      ,
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        editable: (params: any) => {
          return params.data.financeStatus !== 'APPROVED' && params.data.financeStatus !== 'REJECTED';
        },
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 200,
        cellRenderer: (params: any) => {
          if (!params.value) {
            if (params.data.financeStatus === 'APPROVED' || params.data.financeStatus === 'REJECTED') {
              return '<span class="text-muted"></span>';
            }
            return '<span class="text-muted clickable-comment" style="cursor:pointer;color:#aaa;">Click to add comment</span>';
          }

          const shortText =
            params.value?.length > 30 ? params.value.substring(0, 30) + '...' : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },

        // ✅ Prevent save if > 250
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning('Maximum 250 characters allowed');
            return false; // ❌ grid update reject ho jayega (save call nahi hoga)
          }
          params.data.financeComment = params.newValue;
          return true; // ✅ update accept
        },

        onCellClicked: (params: any) => {
          if (params.data.financeStatus === 'APPROVED' || params.data.financeStatus === 'REJECTED') {
            return;
          }

          const editingCells = params.api.getEditingCells();
          const isEditing = editingCells.some(
            (cell: any) => cell.rowIndex === params.rowIndex && cell.column.getId() === params.column.getId()
          );

          if (isEditing) {
            return;
          }

          if (params.value) {
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      }


      ,
      {
        headerName: 'Approval',
        field: 'financeStatus',
        minWidth: 150,

        editable: (params: any) => {
          // compute whether editable (example: editable only when value is missing or PENDING)
          const isEditable = params && params.data &&
            (params.data.financeStatus === null || params.data.financeStatus === undefined || params.data.financeStatus === 'PENDING');

          console.log('editable?', isEditable, 'value=', params.value, 'data=', params.data);
          return isEditable; // <- IMPORTANT: return boolean
        },

        cellEditorSelector: (params: any) => {
          if (!params.value || params.value === 'PENDING') {
            return {
              component: 'agSelectCellEditor',
              params: { values: ['APPROVED', 'REJECTED'] }
            };
          }
          return null;
        },

        cellRenderer: (params: any) => {
          const value = params.value || 'PENDING';
          const color = value === 'APPROVED' ? '#4caf50' : (value === 'REJECTED' ? '#f44336' : '#999');
          const pointer = (value === 'PENDING') ? 'pointer' : 'not-allowed';
          return `
            <span style="
              border:1px solid ${color};
              color:${color};
              background:${color}15;
              cursor:${pointer};
              padding:3px 8px;
              line-height:1.4em;
              border-radius:12px;
              font-size:12px;
              font-weight:500;
              display:inline-block;
            ">
              ${value}
              ${(value === 'PENDING') ? '<span style="font-size:10px;margin-left:6px;color:' + color + '">▼</span>' : ''}
            </span>
          `;
        }
      }

    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        // ✅ Validation: 250 chars max
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanse.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForFinanse.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    this.taskColumnHeaderInfoForFinanse = taskColumnHeaderInfoForFinanse;

    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { headerName: 'Employee Name', isMandatory: true, minWidth: 180, filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 185, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount by Finance', isMandatory: true, minWidth: 250, filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      }
      ,
      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      }
    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        // ✅ Validation: 250 chars max
        valueSetter: (params: any) => {
          if (params.newValue && params.newValue.length > 250) {
            params.context.componentParent.toastr.warning(
              'Manager Comment cannot exceed 250 characters',
              'Warning'
            );
            return false; // reject update
          }
          params.data.managerComment = params.newValue;
          return true;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    this.taskColumnHeaderInfoForFinanceHRAdmin = taskColumnHeaderInfoForFinanceHRAdmin;

  }


  tableDataDetails: any = [];


  // http://localhost:8085/api/uplodphoto/upload-file-locally
  allTeamReimbursement: any = [];
  allTeamMemberReimbursementApprove: any = [];
  currentallTeamMemberReimbursementApprove: any = [];
  allListingEmployeeId: any = [];
  allListingEmployeeIdForTeam: any = [];
  currrentTableDataDetails: any = [];
  fitergetAllFinanceUserDDHrAdmin: any = []


  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object 
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  reimbursementData: any[] = [];


  getAllEmployeeListing() {
    console.log("----------------------3486-----getAllEmployeeListing---------")
    // this.getAllEmployeeListinga()
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        console.log("All reimbursemnt is here ................", response);

        this.tableDataDetails = [];
        this.allTeamMemberReimbursementApprove = [];
        this.allTeamReimbursement = [];

        const rawData = response.data;
        const tableDataDetails = rawData.map((item: any) => ({
          ...item,
          date: this.formatDateOnly(item.date),             // always dd-MM-yyyy
          dateOfExpense: this.formatDateOnly(item.dateOfExpense) //  always dd-MM-yyyy
        }));


        const managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);
        this.httpService.setemployeData(managerEmployeId);
        this.httpService.setReimbursementData(response.data);

        // Immediately get the data if needed
        this.reimbursementData = this.httpService.getReimbursementData();


        // =========================== For Manager + Finance Login =========================================

        if ((this.loggedInUserRole === 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'MD') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
          // For Finance/Manager Login
          console.log("Finance/Manager Login")
          // For Team Reimbursement Condition here --- finance

          // My Reimbursement -- current user login only show Reimbursement data (as employee)
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };

              // Check if employeeId already exists in the array (to avoid duplicates)
              let isDuplicateEmployee = this.allListingEmployeeId.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED") {
                if (!isDuplicateEmployee) {
                  elm.financeStatus = elm.approvedStatus;
                  this.allListingEmployeeId.push(arrEmployeeList); //TODO : main problem
                }
              }
              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
            }
          });



          // For Team Reimbursement Condition here --- mnanager/finanace
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // Check if employeeId already exists in the array
              let isDuplicate = this.allListingEmployeeIdForTeam.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (!isDuplicate) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }// select employee


              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );


              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;

                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }


            }
          })



          // For Team Reimburesement
          this.currrentTableDataDetails = this.allTeamReimbursement;


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            if (elm.status === 'REJECTED_BY_HR_ADMIN') return;
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );



            // Filter and update approved reimbursements
            if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }

            }
            elm.financeStatus = elm.approvedStatus; // status finance
            // console.log( elm.financeStatus);

            this.allTeamMemberReimbursementApprove.push(elm);



          });



          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          }
          else if (this.handalemployeToFinanceCondition === 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE') {
            // Only show Finance entries **after HR approval**
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) =>
                elm.approvedByManager === "APPROVED" &&
                elm.hrAdminId != null && // HR has approved
                ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }

          // 🚀 NEW FIX: Do not show self employee inside Approve tab (Manager + Finance Login)
          this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
            (elm: any) => elm.employeeId != this.loggedInUserId
          );

          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
          console.log("Reimbursement approve data.....", this.currentallTeamMemberReimbursementApprove)


        }
        else if ((this.loggedInUserRole === 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'MD') && ((sessionStorage.getItem('financeAdminId') == '0' || sessionStorage.getItem('financeAdminId') == null) && sessionStorage.getItem('financeAdminId') != this.loggedInUserId)) {
          // For Manager Login

          console.log("For Manager Login=====================")
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };


              this.allListingEmployeeId.push(arrEmployeeList); // select employee

              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
            }
          })




          this.currrentTableDataDetails = this.tableDataDetails;

          // For Team Reimbursement Condition here --- mnanager
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }
              // this.allListingEmployeeIdForTeam.push(arrEmployeeList)
              // Check if employeeId already exists in the array before pushing
              if (!this.allListingEmployeeIdForTeam.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                // --- NEW: Reflect HR Admin rejected status ---
                if (elm.approvedByHrAdmin === 'REJECTED') {
                  elm.approvedByManager = 'REJECTED';
                }

                elm.managerStatus = elm.approvedByManager;
                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }
            }
          })

          this.currrentTableDataDetails = this.allTeamReimbursement;
        }

        else if (this.loggedInUserRole === 'Employee') {


          console.log("Employee Login")
          this.isLoginFinanceEnable = false;

          tableDataDetails?.forEach((elm: any, i: any) => {

            if (this.loggedInUserId == elm.employeeId) {
              console.log("Emp In ");

              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // if (!this.allListingEmployeeId.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
              //   this.allListingEmployeeId.push(arrEmployeeList);
              // }

              const isDuplicate = this.allListingEmployeeId?.some(
                (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

              // Avoid pushing duplicates into tableDataDetails

              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                this.tableDataDetails.push(elm);
              }
            }
          });

          this.currrentTableDataDetails = this.tableDataDetails;   // For Employee


          // For Reimbursement Approve tab


          tableDataDetails.forEach((elm: any) => {
            if (elm.status === 'REJECTED_BY_HR_ADMIN') return;
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

            }


            if (elm.approvedStatus == 'PENDING') {
              elm.approvedStatus = 'PENDING';
            } else if (elm.approvedStatus == 'REJECTED') {
              elm.approvedStatus = elm.approvedStatus;
              elm.financeStatus = elm.approvedStatus;
            } else {
              elm.approvedStatus = 'APPROVED';
              elm.financeStatus = elm.approvedStatus;
            }

            this.allTeamMemberReimbursementApprove.push(elm);
          });



          if (this.handalemployeToFinanceCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          }
          else if (this.handalemployeToFinanceCondition === 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE') {
            // Only show Finance entries **after HR approval**
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) =>
                elm.approvedByManager === "APPROVED" &&
                elm.hrAdminId != null && // HR has approved
                ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }

          this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
            (elm: any) => elm.employeeId != this.loggedInUserId
          );

          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
        }



        // ============================================= HR Admin Login ===============================


        else if (this.loggedInUserRole === 'HR Admin' && this.handalemployeToFinanceCondition === 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE') {
          console.log("HR Admin Login");
          console.log("HRRRRRRRRRRRRRRRRRRRRRRRRR..............1111", tableDataDetails)
          // Assign HR Admin ID to Manager-approved rows if not already assigned
          tableDataDetails.forEach((elm: any) => {
            if (elm.status === 'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN' && !elm.hrAdminId) {
              elm.hrAdminId = this.loggedInUserId;
            }
          });

          const hrPendingReimbursements = tableDataDetails.filter(
            (elm: any) => elm.hrAdminId == this.loggedInUserId
          );

          this.allTeamMemberReimbursementApprove = hrPendingReimbursements;

          // Employee list for HR Admin tab (unique)
          this.allListingEmployeeId = [...new Set(hrPendingReimbursements.map((elm: { employeeId: any, employeeName: any }) => ({
            employeeId: elm.employeeId,
            employeeName: elm.employeeName
          })))];

          // Current table for display
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;

          console.log("HR Admin Current222.......:", this.currentallTeamMemberReimbursementApprove);
          console.log("HR Admin Reimbursements Approves1111111111....:", this.allTeamMemberReimbursementApprove);
        }




        // -------------------- other Login  --------------------



        else {
          console.log("Other Login")

          // allTeamMemberReimbursementApprove // for HR Admin

          tableDataDetails.forEach((elm: any, i: any) => {

            var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );
            // Filter for finance
            if (elm.approvedStatus == 'APPROVED' || elm.approvedStatus == 'REJECTED') {
              if (!isDuplicate) {
                this.fitergetAllFinanceUserDDHrAdmin.push(elm.financeId)

              }
            }


          })
          setTimeout(() => {

            const matchingUsers = this.getAllFinanceUserDD.filter((user: any) => this.fitergetAllFinanceUserDDHrAdmin.includes(user.id));

            this.fitergetAllFinanceUserDD = matchingUsers;



            this.allTeamMemberReimbursementApprove = tableDataDetails

            // this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
            //   (elm: any) => (elm.approvedStatus === "APPROVED")
            // );

            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
            this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;

            // Remove duplicates from allListingEmployeeId for HR login
            this.allListingEmployeeId = this.allListingEmployeeId.filter(
              (obj: { employeeId: any; }, index: any, self: any[]) =>
                index === self.findIndex((t) => t.employeeId === obj.employeeId)
            );

          }, 800)
        }


      });
  }




  addKPISPopup(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    // dialogConfig.width = '80%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '95%' : '80%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      fromYear: this.fromYear,
      toYear: this.toYear,
      data: event,
      year: this.selectedYearForCompetency,

    };
    const dialogRef = this.dialog.open(AddExpenseEmployeeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.isDetailsOpen = false;
      this.getAllEmployeeListing();
    });
  }

  getAllEmployeeListingforEmployeToFinance() {
    this.httpService.callGetService(`${this.config.allReimbursementApplicationForEmployeeToFinance}`)
      .subscribe((result: any) => {
        this.tableDataDetails = result;

        this.tableDataDetails.forEach((elm: any, i: any) => {
          if (elm.uploadDocument) {
            this.tableDataDetails[i].uploadDocument = `${this.config.downloadFile}${elm.uploadDocument}`;
          }
        })


      });
  }
  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }


  deleteEmployee(event: any) {
    // Open the confirmation popup
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you want to Delete?',
        btn1: 'No',
        btn2: 'Yes',
      },
    });

    // Handle the result of the popup
    dialogRef.afterClosed().subscribe((result) => {
      if (result) { // Only proceed if user confirms deletion
        this.httpService.callDeleteService(`${this.config.reimbursementsApplications}/${event}`)
          .subscribe({
            next: (result) => {
              if (result) {
                //123456
                this.getAllEmployeeListing();
                this.isDetailsOpen = false;
                // Show a success message
                this.toastr.success('Reimbursement deleted successfully.', 'success');
              }
            },
            error: (err) => {
              console.error("Error deleting the data:", err);
              // Show an error popup
              this.toastr.error('Failed to delete data. Please try again.', 'error');
            }
          });
      }
    });
  }
  // ------------------------------------------Manager--------------------------------------------------


  ApprovelStatus: any;
  isChecked: boolean = false;

  updateData: any;




  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;


    })
  }
  // 
  // You can use this variable to perform logic when the toggle changes
  toggleChanged() {
    console.log("Toggle is now", this.isChecked ? "Approve" : "Reject");
  }

  //Only for manager login function apply
  fetchAllReimbursementApplication(userId: any) {

    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        const rawData = response.data;
        const arrReimbursementApplication = rawData.map((item: any) => ({
          ...item,
          date: this.formatDateOnly(item.date),             // ✅ always dd-MM-yyyy
          dateOfExpense: this.formatDateOnly(item.dateOfExpense) // ✅ always dd-MM-yyyy
        }));

        console.log("---------------3516-----------------", arrReimbursementApplication)
        const updatedArr = arrReimbursementApplication.map((item: any) => {
          return {
            ...item,
            managerStatus: item.approvedByManager // approvedByManager ki value ko managerStatus me daal rahe hai
          };
        });

        if (userId != undefined) {
          const updatedTableDataDetails = updatedArr.filter((elm: any) => {
            return elm.employeeId === userId;
          });
          this.allTeamReimbursement = updatedTableDataDetails;
        } else {
          this.allTeamReimbursement = updatedArr;
        }
      });
  }



  updateManager(row: any) {
    this.updateData = row;
    let formData = {
      "managerComment": this.updateData?.managerComment,
      "status": (this.updateData?.approvedByManager == null) ? 'PENDING' : this.updateData.approvedByManager,
      "managerId": parseInt(this.loggedInUserId)
    }
    this.httpService.callPutService(`${this.config.reimbursementsUpdateManager}/${this.updateData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {

          this.onCheckIconView = false;
          this.fetchAllReimbursementApplication(this.selectEmployeeIdByManager);
          this.editedIndividualScoreId = this.selectRowId;
          this.isFormDisabled = false;

          this.toastr.success('Reimbursement Application  data updated by Manager Successfully', 'success');

        }

      })
  }
  // ------------------------------------------Finanse--------------------------------------------------




  employeDDFoeHrAdmin: any[] = [];
  getAllEmployeesByDept() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": null,
      "departments": ["Operations", "Product", "Sales"],
      "from": "October-December",
      "fromYear": "2024",
      "to": "October-December",
      "toYear": "2024"
    }
    // this.httpService.callPostService(this.config.getEmpsByDeptByDate, request).subscribe((data: any) => {
    //   this.employeDDFoeHrAdmin = data.data;

    // })
  }
  empyforApprove: any = 'Select All Employee';
  getEmployeeForReimbursement(event: any): void {
    this.selectEmployeeIdByManager = event;

    this.allTeamReimbursement = this.currrentTableDataDetails;
    if (event == '-1') {
      this.allTeamReimbursement = this.currrentTableDataDetails;
    } else {
      // Use the original array to filter and update `tableDataDetails`.
      const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

        return elm.employeeId === event;
      });

      // If matches are found, update the array with the new one.
      if (updatedTableDataDetails.length > 0) {

        this.allTeamReimbursement = updatedTableDataDetails;
      }

    }
  }

  financeIdForEmployee: number = -1; // Default value

  getEmployeeForReimbursementApprove(event: any): void {

    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
        }

      }
    } else {


      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
      } else {
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => (elm.financeId == this.financeIdForEmployee && elm.employeeId == event));

        this.allTeamMemberReimbursementApprove = data;
      }
    }




  }
  selectedEmployeeForFinance: any = -1;
  // For Select Finance 

  getFinaceForReimbursement(event: any) {
    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.tableDataDetails = this.currrentTableDataDetails;
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.tableDataDetails = updatedTableDataDetails;


        }

      }
    } else {
      console.log("all finance data", event)
      this.isShowEmployee = true;
      if (event == -1) return this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.financeId == event);
      this.selectedEmployeeForFinance = -1;

      //  Deduplicate employees by employeeId
      const uniqueEmployeeMap = new Map();
      data.forEach((item: any) => {
        if (!uniqueEmployeeMap.has(item.employeeId)) {
          uniqueEmployeeMap.set(item.employeeId, {
            employeeId: item.employeeId,
            employeeName: item.employeeName
          });
        }
      });
      this.allListingEmployeeId = Array.from(uniqueEmployeeMap.values());

      // Update table data
      const updatedTableDataDetails = data.filter((elm: any) => elm.financeId === event);
      this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      console.log("Reimbursemnt Approve11............", this.allTeamMemberReimbursementApprove)
    }


    //check user list by finance admin


  }

  // updateFinance(row: any) {
  //   this.updateData = row;
  //   if (this.updateData.approvedStatus != 'REJECTED') {
  //     if (this.updateData.assignedAmount == null) {
  //       this.toastr.error('Actual amount by finance Is Required', 'error');

  //       return;
  //     }
  //   }
  //   let formData = {
  //     "financeComment": this.updateData.financeComment,
  //     "approvedStatus": this.updateData.approvedStatus,
  //     "assignedAmount": this.updateData.assignedAmount,
  //     "financeId": parseInt(this.loggedInUserId)
  //   }

  //   this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${this.updateData.reimbursementApplicationId}`, formData)
  //     .subscribe((result) => {
  //       if (result) {
  //         this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');
  //       } 

  //     })
  // }

  managergetData(row: any) {
    if (row.employeeComment?.length === 255 || row.managerComment?.length === 255 || row.financeComment?.length === 255) {
      this.toastr.warning('Maximum 255 characters allowed!', 'Warning');
      // OR use alert('Maximum 255 characters allowed!');
    }
    if (row.assignedAmount && row.assignedAmount.toString().includes('.')) {
      row.assignedAmount = Math.floor(row.assignedAmount);
      this.toastr.warning('Decimal values are not allowed. Converted to whole number.', 'Warning');
    }

  }


  blockDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
    }
  }



  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }


  filteredData: any[] = [];
  searchTaskString: string = '';
  onSearchTask(searchString: string) {

    if (this.loggedInUserRole == 'Employee') {

      let seacrhData = this.tableDataDetails;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.tableDataDetails = [...this.tableDataDetails]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        this.filteredData = seacrhData.filter((row: any) =>
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
        );

        this.tableDataDetails = [...this.filteredData];

      }
    }

  }
}